import { Star } from "lucide-react";
import React from "react";
import { Updater } from "use-immer";

import { IgSelect, IgTypography } from "@intelligems/ig-theme";
import { MenuItem, useTheme } from "@mui/material";

interface MetricDetailSelectProps {
  selectedMetricId: string;
  setSelectedMetricId: Updater<string>;
  dropdownOptions: { title: string; id: string }[];
  isPrimaryMetric: boolean;
}

export const MetricDetailSelect = ({
  selectedMetricId,
  setSelectedMetricId,
  dropdownOptions,
  isPrimaryMetric,
}: MetricDetailSelectProps) => {
  const theme = useTheme();
  return (
    <IgSelect
      disableUnderline={true}
      startAdornment={
        isPrimaryMetric ? (
          <Star
            color={theme.igPrimitives.yellow[500]}
            size={24}
            style={{
              marginRight: "4px",
            }}
          />
        ) : null
      }
      sx={{
        "& .MuiSelect-select": {
          padding: 0,
        },
      }}
      variant={"standard"}
      value={selectedMetricId}
      onChange={(e) => {
        setSelectedMetricId(e.target.value);
      }}
    >
      {dropdownOptions.map((option) => (
        <MenuItem key={option.id} value={option.id}>
          <IgTypography>{option.title}</IgTypography>
        </MenuItem>
      ))}
    </IgSelect>
  );
};
